<script>
    export let allowClose = true;
    import {createEventDispatcher} from 'svelte'
    const dispatch = createEventDispatcher();
    const elementAction = (tag) => {
      dispatch('elementAction', {tag});
    }
    export let show;
</script>

<div class="modal" class:is-active={show}>
  <div class="modal-background"></div>
  <div class="modal-content">
    <div class="card">
      <header class="card-header">
        <p class="card-header-title mb-0">
          <slot name="title"></slot>
        </p>
        {#if (allowClose)}
          <button class="card-header-icon" aria-label="close-modal" on:click={() => elementAction('close')}>
            <span class="icon">
              <i class="fas fa-xmark fa-lg" aria-hidden="true"></i>
            </span>
          </button>
        {/if}
      </header>
      <div class="card-content">
        <div class="content">
          <slot name="content"></slot>
        </div>
      </div>
    </div>
  </div>
</div>


